import React from "react";

// Inline SVGs so the modal stays self-contained (no icon-font dependency) and
// matches the reference design exactly.

export const PlayIcon = () => (
    <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden>
        <path d="M4 2.6 13 8l-9 5.4V2.6Z" fill="currentColor" />
    </svg>
);

export const StopIcon = () => (
    <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden>
        <rect x="3.4" y="3.4" width="9.2" height="9.2" rx="1.4" fill="currentColor" />
    </svg>
);

export const BellMark = () => (
    <svg className="dg-mark" viewBox="0 0 48 48" aria-hidden>
        <path
            d="M24 7a2.6 2.6 0 0 1 2.6 2.6v1.1A10.6 10.6 0 0 1 34.6 21v7.4l2.2 3.6a1.4 1.4 0 0 1-1.2 2.1H12.4a1.4 1.4 0 0 1-1.2-2.1l2.2-3.6V21a10.6 10.6 0 0 1 8-10.3V9.6A2.6 2.6 0 0 1 24 7Z"
            fill="#FFB305"
        />
        <path d="M20.4 36.4h7.2a3.6 3.6 0 0 1-7.2 0Z" fill="#E09A00" />
        <path
            d="M8.6 15.5a13 13 0 0 0 0 17M5 12.5a17.6 17.6 0 0 0 0 23"
            stroke="#047E4F"
            strokeWidth="2.4"
            strokeLinecap="round"
            fill="none"
        />
        <path
            d="M39.4 15.5a13 13 0 0 1 0 17M43 12.5a17.6 17.6 0 0 1 0 23"
            stroke="#0B66DB"
            strokeWidth="2.4"
            strokeLinecap="round"
            fill="none"
        />
    </svg>
);
